var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      {
        staticClass: "base-editor",
        class: { "show-placeholder": _vm.showPlaceHolder },
        style: _vm.disabled === true ? "pointer-events: none;" : "",
        attrs: { id: _vm.editorId }
      },
      [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.textLimitExceeded
      ? _c(
          "div",
          {
            staticClass:
              "typography--caption typography--color-alert text-center pt-12"
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("editor.alerts.max_length", { n: _vm.textLimit })
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e65e264", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e65e264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseEditor.vue
// module id = lkEJ
// module chunks = 1